// extracted by mini-css-extract-plugin
module.exports = {"leadershipRow":"Leadership_leadershipRow__V5YOP"};